import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import type { RendererProps } from "../types";

import { markdownComponents } from "@/components/VibeChat/markdownComponents";

export function MarkdownRenderer({ content }: RendererProps) {
  const source = typeof content.rawValue === "string" ? content.rawValue : content.displayPreview;

  return (
    <div className="prose prose-sm max-w-none dark:prose-invert prose-headings:font-semibold prose-p:leading-relaxed prose-pre:overflow-x-auto">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
        {source}
      </ReactMarkdown>
    </div>
  );
}
